const menu_br={
    "button":{
        "plans":"Planos",
        "career":"Carreiras",
        "contact":"Entre em contato",
        "learnMore":"Saiba mais"
    }
} 
export default menu_br
